import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 38 32"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "m0.10606,3.92693l0,1.05699c0,1.6418 1.3299,2.9717 2.9717,2.9717l31.95661,0c1.6418,0 2.9717,-1.3299 2.9717,-2.9717l0,-1.05699c0,-1.6418 -1.3299,-2.9717 -2.9717,-2.9717l-31.95661,0c-1.6418,0 -2.9717,1.3299 -2.9717,2.9717zm2.9717,15.56894l31.95661,0c1.6418,0 2.9717,-1.3299 2.9717,-2.9717l0,-1.06132c0,-1.6418 -1.3299,-2.9717 -2.9717,-2.9717l-31.95661,0c-1.6418,0 -2.9717,1.3299 -2.9717,2.9717l0,1.05699c0,1.64613 1.3299,2.97603 2.9717,2.97603zm0,11.53592l31.95661,0c1.6418,0 2.9717,-1.3299 2.9717,-2.9717l0,-1.05699c0,-1.6418 -1.3299,-2.9717 -2.9717,-2.9717l-31.95661,0c-1.6418,0 -2.9717,1.3299 -2.9717,2.9717l0,1.05699c0,1.6418 1.3299,2.9717 2.9717,2.9717z"
        })
    }));
};
export default Icon;
